import type { SVGProps } from "react";
export interface PinLocation01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PinLocation01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PinLocation01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.475 16.093c.682.285 1.304.639 1.774 1.078s.876 1.056.876 1.829c0 .906-.552 1.592-1.135 2.052-.597.47-1.39.843-2.27 1.137-1.772.59-4.148.936-6.72.936s-4.948-.346-6.72-.936c-.88-.294-1.673-.667-2.27-1.137-.547-.431-1.066-1.06-1.13-1.884L1.876 19l.019-.282c.084-.641.445-1.161.857-1.547.47-.44 1.092-.793 1.774-1.078l.433 1.039.436 1.037c-.545.228-.903.456-1.106.646a.8.8 0 0 0-.156.183c.021.042.085.14.271.286.315.248.84.52 1.588.77 1.486.495 3.611.82 6.009.82s4.523-.325 6.009-.82c.748-.25 1.273-.522 1.588-.77.185-.146.248-.244.27-.286a.8.8 0 0 0-.155-.183c-.203-.19-.561-.418-1.106-.646l.435-1.037zm-14.95 0a1.125 1.125 0 0 1 .869 2.076zm13.478.604c.24-.573.899-.843 1.472-.604l-.869 2.076c-.572-.24-.843-.9-.603-1.472M13.376 8.25a1.376 1.376 0 1 0-2.752.001 1.376 1.376 0 0 0 2.752 0Zm2.25 0a3.625 3.625 0 1 1-7.25-.001 3.625 3.625 0 0 1 7.25.001"
      />
      <path
        fill={color}
        d="M17.125 8.401c0-2.809-2.336-5.276-5.124-5.276-2.79 0-5.126 2.467-5.126 5.276v.438l.009.317c.09 1.576.838 3.103 1.843 4.456 1.063 1.431 2.338 2.565 3.147 3.214.049.038.093.05.127.05a.2.2 0 0 0 .126-.05c.81-.65 2.084-1.782 3.147-3.214 1.072-1.443 1.85-3.085 1.85-4.773zm2.25.438c0 2.369-1.08 4.479-2.294 6.113-1.222 1.645-2.658 2.917-3.548 3.63a2.434 2.434 0 0 1-3.066 0c-.89-.713-2.326-1.985-3.548-3.63C5.78 13.42 4.759 11.47 4.637 9.28l-.012-.44V8.4c0-3.966 3.26-7.526 7.376-7.526 4.114 0 7.374 3.56 7.374 7.526z"
      />
    </svg>
  );
}
